import { DestroyRef, inject, Pipe, type PipeTransform } from '@angular/core';

@Pipe({ name: 'blobUrl' })
export class BlobUrlPipe implements PipeTransform {
  private readonly destroyRef = inject(DestroyRef);

  transform(file: Blob | undefined) {
    if (!file) {
      return undefined;
    }

    const objectUrl = URL.createObjectURL(file);

    this.destroyRef.onDestroy(() => URL.revokeObjectURL(objectUrl));

    return objectUrl;
  }
}
